<template>
    <div>
        <!-- banner -->
        <hoemBanner />
        <!-- 我们的服务 -->
        <homeServices />
    </div>
</template>

<script>
// banner
import hoemBanner from "../../components/Homecomponent/homeBanner.vue";
// 我们的服务
import homeServices from "../../components/Homecomponent/homeServices.vue";
export default {
    components: {
        hoemBanner,
        homeServices,
    },
};
</script>

<style lang="scss" scoped></style>
